import Gauge from "./gauge.js";
import Json from "./json.js";
import Plot from "./plot.js";
import Value from "./value.js";

const dashboardItem = (type, props) => {
	switch (type) {
		case "gauge": {
			return <Gauge {...props} />;
		}

		case "json": {
			return <Json {...props} />;
		}

		case "plot": {
			return <Plot {...props} />;
		}

		case "value": {
			return <Value {...props} />;
		}

		default: {
			return null;
		}
	}
};

export default dashboardItem;
